enum products {
  marketing = 'marketing',
}

export default products;
